import { Grid, GridItem } from '@imported/constellation';
import React, { useCallback } from 'react';
import { RetakeScreenForm } from '../../components/index.js';
import NeedHelp from '../../components/NeedHelp/index.js';
import { useIdvProvider } from '../../context/index.js';
import { IdvStatus } from '../../types/identityContextTypes.js';
const RetakeScreen = () => {
    const { idvState } = useIdvProvider();
    const { applicationProps, idvStateHandler } = idvState;
    const handleRetakeScreenSubmission = useCallback(async () => await idvStateHandler({
        status: IdvStatus.PREVIOUS,
        body: {
            state: applicationProps,
        },
    }), [idvStateHandler, applicationProps]);
    return (React.createElement(Grid, null,
        React.createElement(GridItem, { md: 8, sm: 12 },
            React.createElement(RetakeScreenForm, { handleRetakeScreenSubmission: handleRetakeScreenSubmission })),
        React.createElement(GridItem, { md: 4, sm: 12 },
            React.createElement(NeedHelp, null))));
};
export default RetakeScreen;
//# sourceMappingURL=index.js.map